import { Dialog } from '@/shad/ui/dialog'
import { ApprovalRule } from '../../../schema'
import { RuleDetailsContent } from './rule-details-content'

interface RuleDetailsDialogProps {
  selectedRuleId: number | null
  rules: ApprovalRule[]
  onOpenChange: (open: boolean) => void
}

// Main component that handles validation and renders the dialog
export function RuleDetailsDialog({
  selectedRuleId,
  rules,
  onOpenChange,
}: RuleDetailsDialogProps) {
  const selectedRule = rules.find((r) => r.id === selectedRuleId)
  const open = !!selectedRule?.id

  // Early return if dialog is not open
  if (!open) {
    return null
  }

  // Early return if rule is not found
  if (!selectedRule) {
    throw new Error('Rule not found')
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <RuleDetailsContent selectedRule={selectedRule} />
    </Dialog>
  )
}
